import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { PermitFile, permitFileDescription, permitFileName, safePermitFileUrl } from '../../../models/permit.model';

// Only ever opened for application/pdf files (see PermitResourcesStepComponent's isPdf gate),
// so the sanitized iframe src is safe: the caller already restricted this to a known-safe,
// backend-controlled file type, not arbitrary user input.
@Component({
    selector: 'app-permit-file-preview-dialog',
    templateUrl: './permit-file-preview-dialog.component.html',
    styleUrls: ['./permit-file-preview-dialog.component.scss'],
})
export class PermitFilePreviewDialogComponent {
    file: PermitFile;
    sanitizedUrl: SafeResourceUrl;

    constructor(
        private dialogRef: MatDialogRef<PermitFilePreviewDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { file: PermitFile },
        private sanitizer: DomSanitizer,
        private translate: TranslateService,
    ) {
        this.file = data.file;
        // isPdf falls back to a `.pdf` regex on the URL, so a scheme like `javascript:` ending
        // in `.pdf` could otherwise pass that gate. Only trust a URL with a safe scheme.
        const safeUrl = safePermitFileUrl(this.file);
        if (!safeUrl) {
            this.dialogRef.close();
        }
        this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(safeUrl ?? 'about:blank');
    }

    get fileName(): string {
        return permitFileName(this.file);
    }

    get fileDescription(): string {
        return permitFileDescription(this.file, this.translate.currentLang || 'fr');
    }

    close(): void {
        this.dialogRef.close();
    }
}
